import { clsx } from "clsx";
import type { ClassValue as ClsxClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export type ClassValue = string | number | false | null | undefined | ClassValue[];

/** Tiny classnames joiner (zero-dependency). */
export function cx(...args: ClassValue[]): string {
  const out: string[] = [];
  for (const a of args) {
    if (!a && a !== 0) continue;
    if (Array.isArray(a)) {
      const s = cx(...a);
      if (s) out.push(s);
    } else {
      out.push(String(a));
    }
  }
  return out.join(" ");
}

/**
 * shadcn's class merger: clsx for conditional composition + tailwind-merge to
 * resolve conflicting Tailwind utilities (last one wins). Every migrated
 * component composes its classes through this.
 */
export function cn(...inputs: ClsxClassValue[]): string {
  return twMerge(clsx(inputs));
}
